import { Reveal, SectionTag } from "./shared";
import { useLanguage } from "@/i18n/LanguageContext";

const MANIFESTO_IMG =
    "https://images.unsplash.com/photo-1786041176778-14825b13576f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const Manifesto = () => {
    const { t } = useLanguage();
    return (
        <section id="manifesto" data-testid="manifesto-section" className="relative py-24 md:py-32">
            <div className="mx-auto max-w-[1400px] px-6 md:px-12">
                <Reveal>
                    <SectionTag index="№ 01" label={t.manifesto.tag} />
                </Reveal>
                <div className="mt-12 grid grid-cols-1 gap-16 md:grid-cols-12">
                    <div className="md:col-span-5">
                        <div className="md:sticky md:top-32">
                            <Reveal>
                                <h2 className="font-display text-4xl leading-[1.05] tracking-tight md:text-5xl">
                                    {t.manifesto.headingA}{" "}
                                    <span className="italic text-gold">{t.manifesto.headingB}</span>.
                                </h2>
                            </Reveal>
                            <Reveal delay={0.15} className="mt-10">
                                <div className="group relative overflow-hidden border border-white/10">
                                    <img
                                        src={MANIFESTO_IMG}
                                        alt="Minimalist modern architecture in shadow"
                                        className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                                    <p className="absolute bottom-6 left-6 font-display text-xl italic text-bone">
                                        {t.manifesto.imageCaption}
                                    </p>
                                </div>
                            </Reveal>
                        </div>
                    </div>
                    <div className="md:col-span-7">
                        {t.manifesto.chapters.map((c, i) => (
                            <Reveal
                                key={c.n}
                                delay={i * 0.1}
                                className={`grid grid-cols-1 gap-6 border-t border-white/10 py-12 sm:grid-cols-12 ${
                                    i === t.manifesto.chapters.length - 1 ? "border-b" : ""
                                }`}
                            >
                                <span className="text-stroke-gold font-display text-6xl leading-none sm:col-span-3 md:text-7xl">
                                    {c.n}
                                </span>
                                <div className="sm:col-span-9">
                                    <h3 className="font-display text-2xl italic tracking-tight text-bone md:text-3xl">
                                        {c.title}
                                    </h3>
                                    <p className="mt-4 max-w-xl text-base leading-relaxed text-ash">
                                        {c.body}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
